import { FC } from "react";

import { SimpleEmbedInstructionsTab } from "@/components/ShareFormModal/SimpleEmbedInstructionsTab";

type EmbedTabProps = {
  orgPageUrl: string;
  onClose: () => void;
  onBackClick: () => void;
};

export const EmbedTab: FC<EmbedTabProps> = ({ orgPageUrl, onClose, onBackClick }) => (
  <SimpleEmbedInstructionsTab
    embedType="OrgPage"
    embedCode={getOrgPageEmbedCode(orgPageUrl)}
    onClose={onClose}
    onBackClick={onBackClick}
  />
);

const getOrgPageEmbedCode = (orgPageUrl: string) =>
  `<iframe title="Organization page powered by Zeffy" style="border:0; width:100%; height:100%; min-width:300px; min-height:600px;" src="${orgPageUrl}"></iframe>`;
